import { ref as m, watch as F, onMounted as Q, onUnmounted as z, readonly as w, defineComponent as W, inject as I, watchEffect as S, computed as X, openBlock as Y, createElementBlock as Z, normalizeStyle as ee, unref as l } from "vue";
const v = Symbol(), U = m(!1), C = m(!1), B = m(!1), T = m(0);
let k = null;
const te = () => {
  const e = document.createElement("script");
  return e.src = "https://accounts.google.com/gsi/client", e.async = !0, e.defer = !0, e;
}, ne = () => {
  C.value = !0, k = te(), document.head.appendChild(k), k.onload = () => {
    C.value = !1, U.value = !0;
  }, k.onerror = () => {
    C.value = !1, B.value = !0;
  };
};
F(
  () => T.value,
  (e, o) => {
    e > 0 && !U.value && !C.value && ne();
  }
);
function A() {
  return Q(() => {
    T.value++;
  }), z(() => {
    T.value--;
  }), {
    scriptLoaded: w(U),
    scriptLoadError: w(B)
  };
}
const oe = /* @__PURE__ */ W({
  __name: "GoogleSignInButton",
  props: {
    oneTap: { type: Boolean },
    autoSelect: { type: Boolean },
    loginUri: {},
    cancelOnTapOutside: { type: Boolean },
    promptParentId: {},
    nonce: {},
    context: {},
    stateCookieDomain: {},
    uxMode: {},
    allowedParentOrigin: {},
    itpSupport: { type: Boolean },
    type: {},
    theme: {},
    size: {},
    text: {},
    shape: {},
    logoAlignment: {},
    width: {},
    locale: {}
  },
  emits: ["success", "error", "intermediateIframeCloseCallback", "nativeCallback", "promptMomentNotification"],
  setup(e, { emit: o }) {
    const n = { large: 40, medium: 32, small: 20 }, t = e, i = o, r = I(v), s = m(null), { scriptLoaded: d } = A();
    S(() => {
      var a, p, f, g;
      d.value && ((a = window.google) == null || a.accounts.id.initialize({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        client_id: r,
        callback: (c) => {
          if (!c.clientId || !c.credential) {
            i("error");
            return;
          }
          i("success", c);
        },
        allowed_parent_origin: t.allowedParentOrigin,
        auto_select: t.autoSelect,
        cancel_on_tap_outside: t.cancelOnTapOutside,
        context: t.context,
        intermediate_iframe_close_callback: () => {
          i("intermediateIframeCloseCallback");
        },
        itp_support: t.itpSupport,
        login_uri: t.loginUri,
        native_callback: (c) => {
          i("nativeCallback", c);
        },
        nonce: t.nonce,
        prompt_parent_id: t.promptParentId,
        state_cookie_domain: t.stateCookieDomain,
        ux_mode: t.uxMode
      }), (f = window.google) == null || f.accounts.id.renderButton(s.value, {
        type: t.type,
        theme: t.theme,
        size: t.size,
        text: t.text,
        shape: t.shape,
        logo_alignment: t.logoAlignment,
        width: (p = t.width) == null ? void 0 : p.toString(),
        locale: t.locale
      }), t.oneTap && ((g = window.google) == null || g.accounts.id.prompt((c) => {
        i("promptMomentNotification", c);
      })));
    }), z(() => {
      var a;
      t.oneTap && ((a = window.google) == null || a.accounts.id.cancel());
    });
    const u = X(() => n[t.size || "large"]);
    return (a, p) => (Y(), Z("div", {
      ref_key: "targetElement",
      ref: s,
      style: ee({ display: "inline-flex", height: u.value })
    }, null, 4));
  }
});
function le(e, o, ...n) {
  var t;
  return ((t = window.google) == null ? void 0 : t.accounts.oauth2.hasGrantedAllScopes(
    e,
    o,
    ...n
  )) || !1;
}
function re(e, o, ...n) {
  var t;
  return ((t = window.google) == null ? void 0 : t.accounts.oauth2.hasGrantedAnyScope(
    e,
    o,
    ...n
  )) || !1;
}
function se(e, o) {
  var n;
  (n = window.google) == null || n.accounts.oauth2.revoke(e, () => {
    o == null || o();
  });
}
function ie(e) {
  const o = "https://accounts.google.com/o/oauth2/v2/auth", n = new URLSearchParams({
    gsiwebsdk: "3",
    client_id: e.client_id,
    scope: e.scope,
    include_granted_scopes: "true",
    access_type: "offline",
    response_type: "code",
    prompt: "consent"
  });
  return e.hint && n.append("hint", e.hint), e.hosted_domain && n.append("hosted_domain", e.hosted_domain), e.redirect_uri === void 0 ? n.append("redirect_uri", window.origin) : n.append("redirect_uri", e.redirect_uri), e.select_account === void 0 ? n.append("select_account", "false") : n.append("select_account", `${e.select_account}`), e.enable_serial_consent === void 0 ? n.append("enable_serial_consent", "false") : n.append(
    "enable_serial_consent",
    `${e.enable_serial_consent}`
  ), e.state && n.append("state", e.state), `${o}?${n.toString()}`;
}
function de(e = {}) {
  const { scope: o = "", onError: n, onSuccess: t, ...i } = e, { scriptLoaded: r } = A(), s = I(v), d = m(!1), u = m(null);
  let a;
  return S(() => {
    var c;
    if (d.value = !1, !r.value)
      return;
    const p = l(o), g = `openid email profile ${Array.isArray(p) ? p.join(" ") : p}`;
    u.value = ie({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      client_id: s,
      scope: g,
      ...i
    }), a = (c = window.google) == null ? void 0 : c.accounts.oauth2.initCodeClient({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      client_id: s,
      scope: g,
      callback: (h) => {
        if (h.error)
          return n == null ? void 0 : n(h);
        t == null || t(h);
      },
      ...i
    }), d.value = !0;
  }), {
    isReady: w(d),
    login: () => a == null ? void 0 : a.requestCode(),
    codeRequestRedirectUrl: w(u)
  };
}
function ue(e) {
  const {
    disableAutomaticPrompt: o = !1,
    onSuccess: n,
    onError: t,
    onPromptMomentNotification: i,
    onNativeCallback: r,
    onIntermediateIframeCloseCallback: s,
    autoSelect: d,
    loginUri: u,
    cancelOnTapOutside: a,
    promptParentId: p,
    nonce: f,
    context: g,
    stateCookieDomain: c,
    allowedParentOrigin: h,
    itpSupport: L
  } = e || {}, { scriptLoaded: P } = A(), $ = I(v), y = m(!1), q = () => {
    var b;
    return y.value && ((b = window.google) == null ? void 0 : b.accounts.id.prompt(
      (x) => i == null ? void 0 : i(x)
    ));
  };
  return S((b) => {
    var G, O;
    if (y.value = !1, !P.value)
      return;
    const x = !l(o), E = l(d), j = l(u), V = l(p), D = l(f), M = l(g), H = l(c), J = l(h), K = l(L), N = l(a);
    (G = window.google) == null || G.accounts.id.initialize({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      client_id: $,
      callback: (_) => {
        if (!_.clientId || !_.credential) {
          t == null || t();
          return;
        }
        n == null || n(_);
      },
      native_callback: (_) => {
        r == null || r(_);
      },
      intermediate_iframe_close_callback: () => {
        s == null || s();
      },
      auto_select: E,
      allowed_parent_origin: J,
      context: M,
      itp_support: K,
      login_uri: j,
      nonce: D,
      prompt_parent_id: V,
      state_cookie_domain: H,
      cancel_on_tap_outside: N
    }), y.value = !0, x && ((O = window.google) == null || O.accounts.id.prompt(
      (_) => i == null ? void 0 : i(_)
    )), b(() => {
      var _;
      (_ = window.google) == null || _.accounts.id.cancel();
    });
  }), { isReady: w(y), login: q };
}
function pe(e = {}) {
  const { scope: o = "", onError: n, onSuccess: t, ...i } = e, { scriptLoaded: r } = A(), s = I(v), d = m(!1);
  let u;
  return S(() => {
    var f;
    if (d.value = !1, !r.value)
      return;
    const a = l(o), p = Array.isArray(a) ? a.join(" ") : a;
    u = (f = window.google) == null ? void 0 : f.accounts.oauth2.initTokenClient({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      client_id: s,
      scope: `openid email profile ${p}`,
      callback: (g) => {
        if (g.error)
          return n == null ? void 0 : n(g);
        t == null || t(g);
      },
      ...i
    }), d.value = !0;
  }), {
    isReady: w(d),
    login: (a) => u == null ? void 0 : u.requestAccessToken(a)
  };
}
function ge(e, o) {
  var n;
  (n = window.google) == null || n.accounts.id.revoke(e, (t) => {
    o == null || o(t);
  });
}
function _e(e) {
  const n = e.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"), t = decodeURIComponent(
    window.atob(n).split("").map((r) => `%${("00" + r.charCodeAt(0).toString(16)).slice(-2)}`).join("")
  ), i = JSON.parse(t);
  return {
    email: i.email,
    email_verified: i.email_verified,
    hd: i.hd,
    family_name: i.family_name,
    given_name: i.given_name,
    name: i.name,
    picture: i.picture,
    id: i.sub
  };
}
const ae = "GoogleSignInPlugin", R = (e) => `[${ae}]: ${e}`, me = {
  install(e, o) {
    if (!o)
      throw new Error(
        R("initialize plugin by passing an options object")
      );
    if (!o.clientId || o.clientId && o.clientId.trim().length === 0)
      throw new Error(R("clientId is required to initialize"));
    e.provide(v, o.clientId), e.component("GoogleSignInButton", oe);
  }
};
export {
  oe as GoogleSignInButton,
  ae as PLUGIN_NAME,
  ie as buildCodeRequestRedirectUrl,
  _e as decodeCredential,
  me as default,
  le as hasGrantedAllScopes,
  re as hasGrantedAnyScopes,
  ge as idRevoke,
  se as revokeAccessToken,
  de as useCodeClient,
  A as useGsiScript,
  ue as useOneTap,
  pe as useTokenClient
};
